import React from 'react';
import { errorToast } from '../../../../utils/Toast/index';

export default function MakeRoomFooterButton(props) {
  const { 
    currentYear, 
    currentMonth, 
    saleOverrides, 
    listAutoUpdate, 
    updateSaleRoom 
  } = props;

  const handleSave = async () => {
    try {
      const monthStr = `${currentYear}-${String(currentMonth + 1).padStart(2, '0')}`;
      
      // compute autoDays from listAutoUpdate
      const autoDaysSet = new Set();
      listAutoUpdate.forEach((isEnabled, dayIndex) => {
        if (isEnabled) {
          autoDaysSet.add(dayIndex + 1);
        }
      });

      updateSaleRoom(autoDaysSet, monthStr, saleOverrides, listAutoUpdate);
    } catch (err) {
      console.error(err);
      errorToast && errorToast('Failed to save overrides');
    }
  };

  return (
    <div>
      <button
        onClick={handleSave}
        style={{
          padding: '10px 20px',
          backgroundColor: '#007bff',
          color: 'white',
          border: 'none',
          borderRadius: '4px',
          cursor: 'pointer',
          fontSize: '16px',
          fontWeight: 'bold'
        }}
        onMouseOver={(e) => e.target.style.backgroundColor = '#0056b3'}
        onMouseOut={(e) => e.target.style.backgroundColor = '#007bff'}
      >
        Save All Changes
      </button>
    </div>
  );
}
